import { HEADER_SOCIAL_MENU } from "@header/HeaderMenuConstants";
import { HeaderMenuList } from "@header/HeaderMenuList";
import type { ReactElement } from "react";

export type SocialProps = {
  testId: string;
};

export function SocialMedia({ testId }: SocialProps): ReactElement {
  return (
    <>
      <HeaderMenuList
        testId={testId}
        items={HEADER_SOCIAL_MENU}
        type="social"
        isHamburger={false}
      />
    </>
  );
}
